import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { OFFER_INCLUDES } from './salesData';
import { BUNDLE_IMAGE_URL } from '../utils/headMeta';
export function OfferSection() {
  return <section id="comprar" className="bg-cream py-11 sm:py-16" data-id="element-125" data-mp="8lls04tbrpex">
      <div className="mx-auto max-w-md px-5 sm:max-w-3xl" data-id="element-126" data-mp="dfq0isi8o5i4">
        <div className="overflow-hidden rounded-[1.75rem] border border-stone bg-white shadow-[0_36px_70px_-52px_rgba(46,35,64,0.6)]" data-id="element-127" data-mp="idrifa3xhys0">
          <div className="grid sm:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] sm:items-center" data-id="element-128" data-mp="mdikwb2ti3cd">
            <div className="bg-sand px-6 py-6 sm:p-7" data-id="element-129" data-mp="rf7tlk2ki4xa">
              <img src={BUNDLE_IMAGE_URL} alt="Los 4 tomos y los 5 bonos de 200 Fórmulas de Velas Artesanales" loading="lazy" decoding="async" width={1254} height={1254} className="mx-auto h-auto w-full max-w-[22rem] object-contain sm:max-w-none" data-id="element-130" data-mp="wcr6afjma9n4" />
            </div>

            <div className="px-6 pb-7 pt-6 text-center sm:p-8 sm:text-left" data-id="element-131" data-mp="xws3xwzyvoti">
              <p className="font-display text-[1.05rem] font-extrabold uppercase leading-tight tracking-tight text-charcoal sm:text-[1.35rem]" data-id="element-132" data-mp="xup82wc4v1gv">
                200 Fórmulas de Velas Artesanales
              </p>

              <ul className="mt-4 inline-flex flex-col gap-1.5 text-left" data-id="element-133" data-mp="1lme4oovzmc3m">
                {OFFER_INCLUDES.map(item => <li key={item} className="flex gap-2.5 font-sans text-[0.86rem] font-semibold leading-snug text-charcoal" data-id="element-134" data-mp="1gmroq7oryhr4">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-135" data-mp="17mv88tcjgp75" />
                    {item}
                  </li>)}
              </ul>

              <PriceBlock className="mt-6 sm:items-start" size="lg" data-id="element-136" data-mp="3scu5o8vyjfvi" />

              <div className="mt-5 flex justify-center sm:justify-start" data-id="element-137" data-mp="3sex2pcvj299q">
                <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-138" data-mp="3tvav46jnxie9" />
              </div>

              <p className="mt-3 font-sans text-[0.72rem] text-taupe/80" data-id="element-139" data-mp="2mnbbv12m38t">
                🔒 Pago seguro · Mercado Pago · Tarjetas de crédito
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}